import { trackFootnoteAccordion, trackFootnoteLink } from '../container/LeadManagementSystemForm/tracking';
import { HandlerEventPair } from '../container/LeadManagementSystemForm/interface';
import { debugInfo } from '../utils/debug';
import { SelectorStyleClass } from '../enum';
import { EventString } from '../container/LeadManagementSystemForm/enum';

let target: HTMLElement;

const footnoteHandler = (e: Event) => {
    if (!(e.target instanceof HTMLElement)) {
        return;
    }

    target = e.target;

    // Prevent event bubbling
    e.preventDefault();

    // Gather the text that belongs to the actual footnote element for tracking
    const textContent = target?.parentElement?.innerText;

    if (!textContent) {
        return;
    }

    const words: string[] = textContent.split(' ');
    const index = words.findIndex(element => element.includes(target.innerText));
    const text = -1 !== index ? 'Hinweise zu: ' + words[index] : '';

    trackFootnoteLink(text);
};

const footnoteAccordionHandler = () => {
    try {
        const [checkBox] = target.getElementsByTagName('input');
        const [textWrapper] = target.getElementsByClassName('closed');

        if (!checkBox?.checked) {
            trackFootnoteAccordion((textWrapper as HTMLElement)?.innerText || '');
        }
    } catch (exception) {
        debugInfo('Footnote-accordion tracking is not functioning: ', exception);
    }
};

const mountComponents = (className: string, { eventString, handler }: HandlerEventPair) => {
    const components = document.getElementsByClassName(className);

    Array.from(components).forEach((element: Element) => {
        element.removeEventListener(eventString, handler);
        element.addEventListener(eventString, handler);
    });
};

/**
 * Mount all the available footnotes on the page
 */
export const mountFootnotes = () => {
    mountComponents(SelectorStyleClass.CLASSNAME_FOOTNOTE_LINK, {
        eventString: EventString.CLICK,
        handler: footnoteHandler,
    });

    mountComponents(SelectorStyleClass.CLASSNAME_FOOTNOTE_ACCORDION, {
        eventString: EventString.MOUSE_DOWN,
        handler: footnoteAccordionHandler,
    });
};

/**
 * Reinit footnotes.
 */
export const reinitFootnotes = () => {
    try {
        window.vf?.footnotes?.init();

        mountFootnotes();
    } catch (err) {
        debugInfo('Footnotes can\'t be initialized. Cause: ', err);
    }
};

/**
 * Returns with all the footnote texts ordered by items inside a string array
 */
export const getFootnoteTextArray = (): string[] => {
    const footnoteTextArray: string[] = [];
    const orderedListElements = document.body.querySelectorAll(SelectorStyleClass.FOOTNOTE_SELECTOR);

    orderedListElements.forEach((listItem) => {
        const txt = listItem.textContent;

        txt && footnoteTextArray.push(txt);
    });

    return footnoteTextArray;
};
